"use strict";

exports.__esModule = true;
exports.default = cx;

function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}
//# sourceMappingURL=cx.js.map